var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3020",
    "data-name": "Group 3020",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 186.72,
    height: 119.551,
    viewBox: "0 0 186.72 119.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #434343;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1651",
    "data-name": "Rectangle 1651",
    className: "cls-1",
    width: 186.72,
    height: 119.549
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4248",
    "data-name": "Path 4248",
    className: "cls-1",
    d: "M2.129,2.126H117.713V89.938H2.129ZM0,92.064H119.841V0H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2996",
    "data-name": "Group 2996",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2995",
    "data-name": "Group 2995",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4249",
    "data-name": "Path 4249",
    className: "cls-1",
    d: "M118.777,29.02H1.064a1.064,1.064,0,1,1,0-2.129H118.777a1.064,1.064,0,1,1,0,2.129",
    transform: "translate(0 47.834)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4250",
    "data-name": "Path 4250",
    className: "cls-1",
    d: "M39.6,52.351H17.6l.492-19.986H39.6ZM19.782,50.222H37.467V34.494h-17.3Z",
    transform: "translate(31.31 57.571)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4251",
    "data-name": "Path 4251",
    className: "cls-1",
    d: "M63.438,50.176H12.374V49.112A10.333,10.333,0,0,1,22.7,38.791h30.42A10.332,10.332,0,0,1,63.438,49.112ZM14.572,48.047H61.243a8.208,8.208,0,0,0-8.125-7.128H22.7a8.206,8.206,0,0,0-8.125,7.128",
    transform: "translate(22.012 69.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4252",
    "data-name": "Path 4252",
    className: "cls-1",
    d: "M33.274,35.368h-11.9a3.048,3.048,0,1,1,0-6.1h11.9a3.048,3.048,0,0,1,0,6.1M21.372,31.4a.92.92,0,1,0,0,1.84h11.9a.92.92,0,1,0,0-1.84Z",
    transform: "translate(32.596 52.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4253",
    "data-name": "Path 4253",
    className: "cls-1",
    d: "M103.878,118.633H46.57V.515h57.308ZM48.7,116.5H101.75V2.644H48.7Z",
    transform: "translate(82.842 0.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4254",
    "data-name": "Path 4254",
    className: "cls-1",
    d: "M102.814,6.7H47.634a1.064,1.064,0,0,1,0-2.129h55.18a1.064,1.064,0,1,1,0,2.129",
    transform: "translate(82.842 8.124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4255",
    "data-name": "Path 4255",
    className: "cls-1",
    d: "M102.814,9.939H47.634a1.064,1.064,0,0,1,0-2.129h55.18a1.064,1.064,0,1,1,0,2.129",
    transform: "translate(82.842 13.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4256",
    "data-name": "Path 4256",
    className: "cls-1",
    d: "M61.685,32.367a7.821,7.821,0,1,1,7.82-7.82,7.827,7.827,0,0,1-7.82,7.82m0-13.514a5.694,5.694,0,1,0,5.691,5.694,5.7,5.7,0,0,0-5.691-5.694",
    transform: "translate(95.818 29.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4257",
    "data-name": "Path 4257",
    className: "cls-1",
    d: "M83.358,36.843H50.826V29.084H83.358ZM52.952,34.717H81.23v-3.5H52.952Z",
    transform: "translate(90.412 51.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4258",
    "data-name": "Path 4258",
    className: "cls-1",
    d: "M83.358,40.086H50.826V32.327H83.358ZM52.952,37.957H81.23v-3.5H52.952Z",
    transform: "translate(90.412 57.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4259",
    "data-name": "Path 4259",
    className: "cls-1",
    d: "M83.358,43.328H50.826V35.569H83.358ZM52.952,41.2H81.23v-3.5H52.952Z",
    transform: "translate(90.412 63.271)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/Desktop.5f6f05b11eef709248a0bd38b50c83a9.svg";
export { ForwardRef as ReactComponent };